import styled from "styled-components";

export const Container = styled.div`
  max-width: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  padding: 79px 24px;

  @media(max-width: 801px) {
    max-width: 100%;
  }
`;

export const Title = styled.h1`
  font-size: 40px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 8px;
  line-height: 52px;
  text-align: center;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: #767676;
  font-family: Inter;
  margin-bottom: 67px;
  text-align: center;
`;

export const CountryGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;

  @media(max-width: 550px) {
    flex-direction: column;
  }
`;

export const CountryCard = styled.div<{ $disabled?: boolean }>`
  flex: 0 1 214px;
  min-height: 96px;
  min-width: max-content;
  padding: 24px 16px; 
  border: 1px solid #F0F0F0;
  border-radius: 8px;
  background: #FCFCFC;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
  transition: all 0.2s ease-in-out;

  &:hover {
    ${(props) =>
      !props.$disabled &&
      `
      border: 1px solid #1A1A1A;
    `}
  }

  @media(max-width: 550px) {
    flex: 1;
  }
`;

export const Flag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  flex-shrink: 0;

  svg, img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const CountryInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CountryName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;